import React from 'react';
import PropTypes from 'prop-types';
import CreditCardComponent from 'components/creditCard/Form';
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';

const CreditCard = ({ className, handleBack }) => (
  <AuthenticatedUserView className={className} handleBack={handleBack}>
    <section className="main" role="main">
      <CreditCardComponent />
    </section>
  </AuthenticatedUserView>
);

CreditCard.propTypes = {
  className: PropTypes.string,
  handleBack: PropTypes.func.isRequired,
};

CreditCard.defaultProps = {
  className: '',
};

export default CreditCard;
